var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"875.917799667940926 386.676399554185991 875.917799667940926 161.595551070251531 727.129848175730331 161.595551070251531 727.129848175730331 255.563889039373862 540 90.664281017883695 6.307698525295564 560.955701918857812 153.225595277620414 560.955701918857812 153.225595277620414 989.335718982116305 280.766882086138139 989.335718982116305 403.049805946735432 989.335718982116305 433.261184350233634 989.335718982116305 433.261184350233634 680.720867749676472 646.738815649765456 680.720867749676472 646.738815649765456 989.335718982116305 676.950194053262749 989.335718982116305 824.165700467273382 989.335718982116305 926.774404722379586 989.335718982116305 926.774404722379586 560.955701918857812 1073.692301474703527 560.955701918857812 875.917799667940926 386.676399554185991"}));
}

Home.defaultProps = {"id":"ICONS","viewBox":"0 0 1080 1080"};

module.exports = Home;

Home.default = Home;
